import {
  Panel
} from '@roc/ui';

export {
  Panel,
  PanelProps
} from '@roc/ui';

export default Panel;